import { useEffect, useState } from 'react';
import { marketplaceaccountApi, type ConnectionHealth, type MarketplaceAccount } from '../../api/marketplaceaccount';

export function HealthDashboardPage() {
  const [accounts, setAccounts] = useState<MarketplaceAccount[]>([]);
  const [healthMap, setHealthMap] = useState<Record<string, ConnectionHealth>>({});
  const [error, setError] = useState('');

  useEffect(() => {
    void marketplaceaccountApi.list().then(async (list) => {
      setAccounts(list);
      const map: Record<string, ConnectionHealth> = {};
      await Promise.all(list.map(async (a) => {
        try {
          map[a.id] = await marketplaceaccountApi.health(a.id);
        } catch { /* skip */ }
      }));
      setHealthMap(map);
    }).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Connection Health</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {accounts.map((a) => {
          const h = healthMap[a.id];
          return (
            <div key={a.id} className="rounded-xl border bg-white p-4">
              <h2 className="font-medium">{a.display_name}</h2>
              <p className="text-sm text-slate-500">{a.marketplace} · {a.account_code}</p>
              {h ? (
                <div className="mt-3 space-y-1 text-sm">
                  <p>Score: <strong>{h.score}</strong></p>
                  <p>Connection: {h.connection_status}</p>
                  <p>Token: {h.token_status}</p>
                  <p>Credential: {h.credential_status}</p>
                  <p className="text-slate-600">{h.message}</p>
                </div>
              ) : (
                <p className="mt-3 text-sm text-slate-400">Loading health…</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
